var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSingularinline = function SvgSingularinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#singular_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "singular_inline_svg__b",
    width: 16,
    height: 17,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16-.254H0V16h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3088F4",
    mask: "url(#singular_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.77 2.976a8.82 8.82 0 0 1 1.527 5.078c0 .034.028.067.066.067a.07.07 0 0 0 .055-.028q.204-.351.368-.719a7.69 7.69 0 0 0 .16-5.892A7.75 7.75 0 0 0 7.032-.185a.07.07 0 0 0-.055.078c.006.022.017.045.039.05a8.27 8.27 0 0 1 3.753 3.033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.616 7.738a8.55 8.55 0 0 1-3.705 4.058c-.033.017-.038.056-.022.089.011.017.033.034.05.034.39 0 .78-.028 1.17-.095a7.8 7.8 0 0 0 4.798-2.776 8.06 8.06 0 0 0-1.539-6.076.06.06 0 0 0-.088-.012c-.016.017-.027.04-.021.062a8.57 8.57 0 0 1-.643 4.716M5.449 2.949a8.04 8.04 0 0 1 4.836 1.215c.028.017.072.012.088-.022a.07.07 0 0 0 0-.067 6 6 0 0 0-.357-.574A7.45 7.45 0 0 0 5.03.313 8.05 8.05 0 0 0 .624 4.694a.06.06 0 0 0 .033.084c.022.01.044.005.066-.006A8.77 8.77 0 0 1 5.449 2.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.27 12.736a8.04 8.04 0 0 1-5.71-1.22c-.028-.018-.072-.012-.089.022a.07.07 0 0 0 0 .066q.216.402.49.77a7.95 7.95 0 0 0 4.995 3.071 8.1 8.1 0 0 0 4.424-4.392.06.06 0 0 0-.033-.084c-.022-.011-.044-.006-.066.006a9 9 0 0 1-4.012 1.761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.246 12.926a8.2 8.2 0 0 1-1.589-5.207.067.067 0 0 0-.066-.067.07.07 0 0 0-.054.028 5 5 0 0 0-.32.602 7.82 7.82 0 0 0-.197 5.926 7.83 7.83 0 0 0 5.996 1.722.07.07 0 0 0 .055-.078c-.006-.022-.017-.044-.039-.05a8.8 8.8 0 0 1-3.786-2.876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.311 7.942a8.05 8.05 0 0 1 3.66-3.985c.033-.017.039-.056.022-.09-.01-.016-.033-.033-.05-.033a7 7 0 0 0-.675.017A7.5 7.5 0 0 0 .102 6.632a8.08 8.08 0 0 0 1.511 6.132c.022.028.06.034.088.011.017-.016.028-.039.022-.06a9.14 9.14 0 0 1 .588-4.773"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "singular_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSingularinline;